<template>
  <v-dialog v-model="dialog" width="600">
    <v-card>
      <gg-toolbar @close="close">
        Delete Database
      </gg-toolbar>

      <v-card-text>
        <p>Are you sure you wish to <strong>permanently</strong> remove the database “{{ database.db }}”?</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <gg-btn class="mb-0" secondary @click="close">Cancel</gg-btn>
        <gg-btn
          :loading="loading"
          class="mb-0"
          @click="deleteDatabase"
        >
          Delete
        </gg-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DeleteDatabaseModal',
  props: {
    database: {
      type: Object,
      required: true
    },
    opened: {
      type: Boolean,
      required: true
    },
  },
  data () {
    return {
      loading: false,
    }
  },
  computed: {
    dialog: {
      get () {
        return this.opened
      },
      set () {
        this.close()
      }
    },
  },
  methods: {
    ...mapActions({
      deleteMysqlDatabase: 'mysql/deleteMysqlDatabase',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError'
    }),
    async deleteDatabase () {
      this.loading = true
      try {
        await this.deleteMysqlDatabase({ name: this.database.db, _username: this.$route.query.user })
        this.reportSuccess(`Database “${this.database.db}” deleted.`)
        this.$emit('action-completed', 'database-deleted')
        this.loading = false
        this.close()
      } catch (e) {
        this.reportError(e)
      }
    },
    close () {
      this.$emit('close')
    },
  }
}
</script>
